<div class="wrapper">
  <pmv-header [title]="appConfig.title" [version]="appConfig.version" [timeLogout]="appConfig.timeLogout">
    <pmv-profile></pmv-profile>
  </pmv-header>
  <router-outlet></router-outlet>
  <pmv-footer></pmv-footer>

  <pmv-snackbar></pmv-snackbar>
  <pmv-confirm-dialog></pmv-confirm-dialog>

  <button type="button" class="btn voltarTopo" value="Voltar ao topo">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </button>
</div>




// WEBPACK FOOTER //
// ./src/app/app.component.html